module.exports = __webpack_public_path__ + "static/media/forest.0166642c.jpg";